import { JUSBRASIL_DOMAIN, PRODUCTION_ORIGIN } from '../host-origin'

export const PRODUCTION_APEX_ORIGIN = `https://${JUSBRASIL_DOMAIN}`

export const ALLOWED_BROWSER_ORIGINS: readonly string[] = [
  PRODUCTION_ORIGIN,
  PRODUCTION_APEX_ORIGIN,
]

export const ALLOWED_STAGING_ORIGIN_PATTERN =
  /^https:\/\/([a-z0-9-]+\.)?staging\.jusbrasil\.com\.br$/

export const ALLOWED_LOCAL_ORIGIN_PATTERN =
  /^https?:\/\/(localhost|local\.jusbrasil\.com\.br)(:\d+)?$/

// Origin allow-list gate for the browser-facing metrics bridges. Single-sourced
// because it is a security boundary on public POST endpoints — drift between
// copies is exactly the failure to avoid.
export const isAllowedApiOrigin = (origin: string | undefined): origin is string => {
  if (!origin) return false
  return (
    ALLOWED_BROWSER_ORIGINS.includes(origin) ||
    ALLOWED_STAGING_ORIGIN_PATTERN.test(origin) ||
    ALLOWED_LOCAL_ORIGIN_PATTERN.test(origin)
  )
}
